<template>
  <span class="delete-confirm-trigger" @click="showConfirm">
    <slot />
  </span>
</template>

<script>
export default {
  name: 'DeleteConfirm',
  props: {
    title: {
      type: String,
      default: '确认删除该条数据吗？删除后无法恢复。'
    },
    okText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    }
  },
  methods: {
    invokeConfirm() {
      const confirm = this.$listeners.confirm
      if (!confirm) return Promise.resolve()

      try {
        return Promise.resolve(confirm())
      } catch (error) {
        return Promise.reject(error)
      }
    },
    showConfirm() {
      this.$confirm({
        title: '删除确认',
        content: this.title,
        okText: this.okText,
        okType: 'danger',
        cancelText: this.cancelText,
        onOk: () => this.invokeConfirm(),
        onCancel: () => {
          this.$emit('cancel')
        }
      })
    }
  }
}
</script>

<style scoped>
.delete-confirm-trigger {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/DeleteConfirm/index.vue